export enum PageType {
    pastOrders = 'past-orders',
    favourites = 'favourites',
  }
  